import React from "react";
import { ExpendableLink } from "./expendable-link";
import {
  Crosshair,
  LayoutDashboard,
  Package,
  ScanSearch,
  GitCompare,
  DollarSign,
  Heart,
} from "lucide-react";

export const ClientMenu: React.FC = () => {
  return (
    <>
      <ExpendableLink
        url="/"
        title="Dashboard"
        icon={<LayoutDashboard size={18} />}
      />

      <ExpendableLink
        title="Cibles"
        url="/sites"
        icon={<Crosshair size={18} />}
      />
      <ExpendableLink
        title="Produits"
        url="/products"
        icon={<Package size={18} />}
      />
      <ExpendableLink
        title="Price"
        url="/products-price-only"
        icon={<DollarSign size={16} />}
      />
      <ExpendableLink
        title="Reférences"
        url="/references"
        icon={<Crosshair size={18} />}
      />

      <ExpendableLink
        title="Analyses"
        url="/scans"
        icon={<ScanSearch size={18} />}
      />
      <ExpendableLink
        title="Comparaison"
        url="/compare"
        icon={<GitCompare size={18} />}
      />
      <ExpendableLink
        title="Favoris"
        url="/favorites"
        icon={<Heart size={18} />}
      />
    </>
  );
};
